import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import styles from './Login.module.scss';
import homeImage from '../../../assets/landingPage.png';
import logo from '../../../assets/Logo.png';
import { Input, Button } from '@src/components/ui';
const Login = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [form, setForm] = useState({
        email: '',
        password: '',
    });
    const [error, setError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const handleChange = (field) => (value) => {
        if (passwordError)
            setPasswordError('');
        if (emailError)
            setEmailError('');
        setForm((prev) => ({ ...prev, [field]: value }));
    };
    const handleSubmit = async () => {
        setError('');
        setLoading(true);
        const loginResponse = await login({
            email: form.email,
            password: form.password,
        });
        if (loginResponse.passwordError) {
            setPasswordError(loginResponse.passwordError);
        }
        if (loginResponse.usernameError) {
            setEmailError(loginResponse.usernameError);
        }
        if (!loginResponse.ok) {
            setError(loginResponse.message);
        }
        setLoading(false);
        if (loginResponse.isSuccess) {
            setSuccessMessage('Login successful!');
            const canAccessAdminPortal = Boolean(loginResponse.user?.isStaff ?? loginResponse.user?.is_staff);
            if (canAccessAdminPortal) {
                setTimeout(() => navigate('/web-admin'), 1500);
            }
            else {
                setTimeout(() => navigate('/'), 1500);
            }
        }
    };
    const clearForm = () => {
        setError('');
        setForm({
            email: '',
            password: '',
        });
    };
    return (_jsxs("div", { className: styles.createAccountWrapper, children: [successMessage && _jsx("div", { className: styles.successBanner, children: successMessage }), _jsx("img", { src: homeImage, alt: "Veterinary technology for animal care", className: styles.fullscreenBackground }), _jsxs("div", { className: styles.inputContainer, children: [_jsx(Link, { to: "/", className: styles.nav__logoWrapper, children: _jsx("img", { src: logo, style: { height: '50px', width: '217px' } }) }), _jsx("h2", { children: " Sign in." }), _jsx(Input, { label: !emailError ? 'Name' : `Name: ${emailError}`, className: styles.inputItem, width: "100%", value: form.email, onChange: handleChange('email'), onFocus: () => (error || passwordError || emailError) && clearForm(), error: !!emailError || !!error }), _jsx(Input, { label: !passwordError ? 'Password' : `Password: ${passwordError}`, type: "password", className: styles.inputItem, width: "100%", value: form.password, onChange: handleChange('password'), error: !!passwordError || !!error, onFocus: () => (error || passwordError || emailError) && clearForm() }), error && _jsx("p", { className: styles.error, children: error }), _jsx(Button, { variant: "primaryV2", label: loading ? 'Logging In...' : 'Login', size: "large", onClick: handleSubmit, disabled: loading, className: styles.loginButton }), _jsx("div", { className: styles.forgotContainer, children: _jsx(Link, { to: "/account/forgot-password", children: "Forgot password?" }) })] }), _jsxs("div", { className: styles.registerContainer, children: [_jsx("span", { children: "New to Endurance?" }), _jsx(Link, { to: `/account/createAccount`, children: "Register Here" })] })] }));
};
export default Login;
